import { useSelector, useDispatch } from 'react-redux';
import {
  setSuppliers,
  setSelectedSupplier,
  setSelectedEntity,
  setLoading,
  setError,
  clearEntity,
} from '../actions/reduxActions';
import { getCompanySuppliersAction } from '../../../../v2/APIs/action';
export const useEntityState = () => {
  const dispatch = useDispatch();
  const entityState = useSelector((state) => state.entityReducer);

  const fetchSuppliers = async (module = 'default', params = {}) => {
    try {
      dispatch(setLoading(true));
      const { data, error, message } = await getCompanySuppliersAction(module, params);
      if (!error && data && Array.isArray(data)) {
        dispatch(setSuppliers(data));
      } else {
        dispatch(setError(message || 'Failed to fetch suppliers'));
      }
    } catch (err) {
      dispatch(setError(err.message || 'An error occurred'));
    }
  };

  const selectSupplier = (supplierId) => {
    dispatch(setSelectedSupplier(supplierId));
  };

  const selectEntity = (entityId) => {
    dispatch(setSelectedEntity(entityId));
  };

  const clear = () => {
    dispatch(clearEntity());
  };

  return {
    ...entityState,
    fetchSuppliers,
    selectSupplier,
    selectEntity,
    clear,
  };
};